import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/arr-right.png'


const _withScopeId = n => (_pushScopeId("data-v-13b196aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "cloumn-list-wrapper"
}
const _hoisted_2 = { class: "tit-wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "box" }
const _hoisted_5 = { class: "filter-wrapper" }
const _hoisted_6 = { class: "filter-box filter1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("其他品牌"),
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon",
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "加载更多", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tab_list = _resolveComponent("tab-list")!
  const _component_custom_btn = _resolveComponent("custom-btn")!
  const _component_dealer_news_list = _resolveComponent("dealer-news-list")!

  return (_ctx.brandList.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.columnImgUrl,
            alt: ""
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_tab_list, {
                tabName: '品牌：',
                activeColor: _ctx.activityInfo.subjectRgb,
                curTabIndex: _ctx.curBrandTabIndex,
                list: _ctx.brandList,
                onChangeTabItem: _ctx.changeTabItem
              }, null, 8, ["activeColor", "curTabIndex", "list", "onChangeTabItem"]),
              _createVNode(_component_custom_btn, {
                id: "cxSelect",
                onClick: _ctx.openCarSideBar,
                btnType: 'tab-btn1',
                bgColor: '#ffffff',
                color: '#656565'
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createVNode(_component_dealer_news_list, {
            list: _ctx.dealerNewsList,
            noResult: _ctx.noResult,
            isShowLoading: _ctx.isShowLoading
          }, null, 8, ["list", "noResult", "isShowLoading"]),
          _withDirectives(_createVNode(_component_custom_btn, {
            onClick: _ctx.getMoreData,
            class: "load-more-btn",
            "btn-type": 'load-more',
            bgColor: 'rgba(255,255,255,.5)',
            color: '#656565'
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["onClick", "bgColor"]), [
            [_vShow, !_ctx.isShowLoading && _ctx.dealerNewsList.length < _ctx.total]
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}